/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import { css } from "@emotion/react";

const pageSectionCss = css`
  margin-bottom: 12px;

  &.sibling + .sibling {
    margin-top: 16px;
  }
`;

const generateClassName = (className) => `sibling${className ? ` ${className}` : ""}`;

export default function PageSection({ className, ...props }) {
  return <section css={pageSectionCss} {...props} className={generateClassName(className)} />;
}

PageSection.propTypes = {
  className: PropTypes.string,
};
